import { Breadcrumbs, Typography, Link } from "@mui/material";
import { useAtributosComprasCadastroViewModel } from "../../viewModels/atributos_compras_cadastro_view_model";
import { FormSwitchInput } from "../../../../../common/components/masked_inputs/react_forms/form_switch_input";
import { DefaultFormNumericInput } from "../../../../../common/components/default_form_numeric_input";

import AlertError from "../../../../../common/components/alert_error";
import RefreshButton from "../../../../../common/components/refresh_button";
import BottomBar from "../../../../../common/components/bottom_bar";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import DefaultFormInput from "../../../../../common/components/default_form_input";

/**
 * AtributosComprasCadastro
 */

export const AtributosComprasCadastro = () => {
  const viewModel = useAtributosComprasCadastroViewModel();
  return (
    <>
      {/**
        * Page
        */}

      <form onSubmit={viewModel.handleSubmit}>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Compras
            </Link>
            <Typography className="text-primary-green">
              Configuração de Compras
            </Typography>
          </Breadcrumbs>

          <div className="flex flex-col gap-2">
            <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
              <div className="flex gap-2 items-center w-full">
                <h1 className="text-3xl font-medium text-black dark:text-white">Configuração de Compras</h1>
                <RefreshButton onClick={viewModel.handleReload} />
              </div>

              <div className="w-full justify-end flex gap-2">
              </div>
            </div>
          </div>
          {
            viewModel.errorMessage !== undefined
              ? (
                <div className="w-full">
                  <AlertError
                    messageErro={viewModel.errorMessage}
                    onTryAgain={viewModel.handleReload} />
                </div>
              ) : (
                <>
                  <div className="w-full flex flex-col gap-2 p-4 bg-light-mode-2 dark:bg-dark-mode-2 rounded border border-border-light-mode dark:border-border-dark-mode text-black dark:text-white">
                    <h1 className="text-xl text-black dark:text-white font-semibold">Cadastrar/Editar Configurações</h1>
                    <div className="w-full flex flex-col gap-4">
                      <div className="w-full grid md:grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4">
                        <div className="w-full flex flex-row gap-4 items-center">
                          <span>Exibir Data do Cadastro</span>
                          <FormSwitchInput
                            name='exibirDataCadastro'
                            activeLabel='Sim'
                            inactiveLabel='Não'
                            readOnly={viewModel.saving}
                            reactHookForm={viewModel.hookForm}
                          />
                        </div>

                        <div className="w-full flex flex-row gap-4 items-center">
                          <span>Exibir Data de Cadastro/Edição da Requisição</span>
                          <FormSwitchInput
                            name='exibirDataCadastroRequisicao'
                            activeLabel='Sim'
                            inactiveLabel='Não'
                            readOnly={viewModel.saving}
                            reactHookForm={viewModel.hookForm}
                          />
                        </div>

                        <div className="w-full flex flex-row gap-4 items-center">
                          <span>Exibir Data de Aprovação de Coleta de Preço</span>
                          <FormSwitchInput
                            name='exibirDataAprovacaoColetaPreco'
                            activeLabel='Sim'
                            inactiveLabel='Não'
                            readOnly={viewModel.saving}
                            reactHookForm={viewModel.hookForm}
                          />
                        </div>
                      </div>

                      <DefaultFormNumericInput
                        name='notaCorte'
                        label='Nota de Corte do Fornecedor'
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='observacoes'
                        label='Observações'
                        multiline={true}
                        rows={7}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>
                  </div>
                </>
              )
          }
        </div>

        {/**
          * BottomBar
          */}

        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
            </div>

            <div className="flex flex-row gap-4">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              </div>
              <div className="w-[130px]">
                {viewModel.saving
                  ? (
                    <PrimaryButton>
                      Salvando...
                    </PrimaryButton>
                  ) : (
                    <PrimaryButton
                      type="submit"
                      startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                      Salvar
                    </PrimaryButton>
                  )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>
    </>
  );
}